// src/hooks/usePortalNotificationsInHome.ts

import { useEffect, useState, useMemo } from "react";

import { useNotificationPortal } from "@context/notification/hook/useNotificationPortal";

export const usePortalNotificationsInHome = () => {
  const {
    state: { notifications, open },
    action: { reopen, autoFetchGetNotificationsReadUnread },
  } = useNotificationPortal();

  // Evitar abrir o modal automaticamente TODA vez que mudar a lista
  const [autoOpenedOnce, setAutoOpenedOnce] = useState(false);

  // 1) Buscar notificações (read/unread) ao montar a Home
  useEffect(() => {
    void autoFetchGetNotificationsReadUnread();
  }, [autoFetchGetNotificationsReadUnread]);

  // 2) Se houver não lidas e o modal ainda não abriu automaticamente,
  //    abre a primeira não lida.
  useEffect(() => {
    if (autoOpenedOnce) return;

    const firstUnread = notifications.find((n) => !n.readAt);
    if (firstUnread && !open) {
      reopen(firstUnread.id);
      setAutoOpenedOnce(true);
    }
  }, [notifications, open, reopen, autoOpenedOnce]);

  const unreadCount = useMemo(
    () => notifications.filter((n) => !n.readAt).length,
    [notifications]
  );

  return {
    notifications,
    unreadCount,
    hasUnread: unreadCount > 0,
  };
};

export default usePortalNotificationsInHome;
